import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, throwError } from 'rxjs';
import { environment } from '../../environment/environment';
import {
  CooperationBackendModel,
  CooperationCreateUpdateModel,
  CooperationModel,
} from '../models/cooperation.model';

@Injectable({
  providedIn: 'root',
})
export class CooperationService {
  constructor(private http: HttpClient) {}

  public getCooperationById(
    cooperationId: number
  ): Observable<CooperationModel> {
    const formData = new FormData();
    formData.append('mode', 'getCooperationById');
    formData.append('id', cooperationId.toString());

    return this.http
      .post<{
        success: boolean;
        message: string;
        data: CooperationBackendModel;
      }>(environment.authority_short + 'cooperation.php', formData)
      .pipe(
        map(response => this.parseBackendCooperation(response.data)),
        catchError(() => {
          return throwError(() => new Error('Cooperation fetch failed'));
        })
      );
  }

  public getCooperations(): Observable<CooperationModel> {
    const formData = new FormData();
    formData.append('mode', 'getCooperations');

    return this.http
      .post<{
        success: boolean;
        message: string;
        data: CooperationBackendModel;
      }>(environment.authority_short + 'cooperation.php', formData)
      .pipe(
        map(response => this.parseBackendCooperation(response.data)),
        catchError(() => {
          return throwError(() => new Error('Cooperation fetch failed'));
        })
      );
  }

  public createCooperation(
    cooperation: CooperationCreateUpdateModel
  ): Observable<any> {
    const formData = new FormData();
    formData.append('mode', 'createCooperation');
    formData.append('cooperation_name', cooperation.cooperation_name);
    formData.append('firstname', cooperation.firstname);
    formData.append('lastname', cooperation.lastname);
    formData.append('email', cooperation.email);
    formData.append('phone_number', cooperation.phone_number);
    cooperation.sponsor_cards.forEach((card, index) => {
      formData.append(`sponsor_cards[${index}][title]`, card.title);
      card.description &&
        formData.append(
          `sponsor_cards[${index}][description]`,
          card.description
        );
      card.link && formData.append(`sponsor_cards[${index}][link]`, card.link);
      formData.append(
        `sponsor_cards[${index}][active]`,
        card.active === false ? '0' : '1'
      );
      formData.append(`sponsor_cards[${index}][image]`, card.image);
    });

    return this.http
      .post<{
        success: boolean;
        message: string;
        data: CooperationBackendModel;
      }>(environment.authority_short + 'cooperation.php', formData)
      .pipe(
        map(response => response),
        catchError(() => {
          return throwError(() => new Error('Cooperation fetch failed'));
        })
      );
  }

  public updateCooperation(
    cooperation: CooperationCreateUpdateModel
  ): Observable<any> {
    const formData = new FormData();
    formData.append('mode', 'updateCooperation');
    formData.append('id', cooperation.id.toString());
    formData.append('cooperation_name', cooperation.cooperation_name);
    formData.append('firstname', cooperation.firstname);
    formData.append('lastname', cooperation.lastname);
    formData.append('email', cooperation.email);
    formData.append('phone_number', cooperation.phone_number);
    cooperation.sponsor_cards.forEach((card, index) => {
      card.id &&
        formData.append(`sponsor_cards[${index}][id]`, card.id.toString());
      formData.append(`sponsor_cards[${index}][title]`, card.title);
      card.description &&
        formData.append(
          `sponsor_cards[${index}][description]`,
          card.description
        );
      card.link && formData.append(`sponsor_cards[${index}][link]`, card.link);
      formData.append(
        `sponsor_cards[${index}][active]`,
        card.active === false ? '0' : '1'
      );
      formData.append(`sponsor_cards[${index}][image]`, card.image);
    });

    return this.http
      .post<{
        success: boolean;
        message: string;
        data: CooperationBackendModel;
      }>(environment.authority_short + 'cooperation.php', formData)
      .pipe(
        map(response => response),
        catchError(() => {
          return throwError(() => new Error('Cooperation fetch failed'));
        })
      );
  }

  public checkSponsorCardDeletion(sponsorCardId: number): Observable<boolean> {
    const formData = new FormData();
    formData.append('mode', 'checkSponsorCardDeletion');
    formData.append('id', sponsorCardId.toString());

    return this.http
      .post<{
        success: boolean;
        message: string;
      }>(environment.authority_short + 'cooperation.php', formData)
      .pipe(
        map(response => response.success),
        catchError(error => {
          return throwError(() => error);
        })
      );
  }

  public deleteCooperation(cooperationId: number): Observable<any> {
    const formData = new FormData();
    formData.append('mode', 'deleteCooperation');
    formData.append('id', cooperationId.toString());

    return this.http
      .post<{
        success: boolean;
        message: string;
      }>(environment.authority_short + 'cooperation.php', formData)
      .pipe(
        map(response => response),
        catchError(error => {
          return throwError(() => error);
        })
      );
  }

  public parseBackendCooperation(
    cooperationData: CooperationBackendModel
  ): CooperationModel {
    return {
      id: cooperationData.id,
      cooperationName: cooperationData.cooperation_name,
      firstname: cooperationData.first_name,
      lastname: cooperationData.last_name,
      email: cooperationData.email,
      phoneNumber: cooperationData.phone_number,
      sponsorCards: cooperationData.sponsor_cards,
    };
  }
}
